import type { ProcessingState } from "@redux/state/shared-types";
import { checkBatchParticipationCompletion, resetCheckBatchParticipationCompletion } from "./check-batch-participation-completion";
import { createReducer } from "@reduxjs/toolkit";

const initialState: ProcessingState = { processing: "idle" };

export const checkBatchParticipationCompletionReducer = createReducer<ProcessingState>(initialState, builder => {
  builder
    .addCase(checkBatchParticipationCompletion.fulfilled, state => ({
      ...state,
      processing: "success",
    }))
    .addCase(checkBatchParticipationCompletion.pending, state => ({
      ...state,
      processing: "pending",
    }))
    .addCase(checkBatchParticipationCompletion.rejected, state => ({
      ...state,
      processing: "failed",
    }));

  builder.addCase(resetCheckBatchParticipationCompletion, () => initialState);
});
